export default {
  paid: 'Paid',
  pendingPayment: 'Pending Payment',
  seeOpd: 'View OPD Info',
  seeDoctorInfo: 'View Doctor Info',
  searchNoNamDoctor: 'Search Staff ID or Doctor Name',
  staffNo: 'Staff ID',
  title: {
    opdReport: 'OPD Report',
    formulaAndTreadment: 'Product, Prescription, and Treatment List',
    physicalExaminationInfo: 'Physical Examination Info',
    editPhysicalExaminationInfo: 'Edit Physical Examination Info',
    diagnosisAndTreatment: 'Diagnosis and Treatment',
    beforeAfterImages: 'Before-After Images',
    documents: 'Documents',
    history: 'Medical Certificate Issuance History',
    shortMedCertHistory: 'Short Medical Certificate History',
    otherImportantHistory: 'Other Important History',
    opdCreatedTime: 'OPD Creation Time'
  },
  header: {
    productList: 'Product List',
    formulaList: 'Prescription List',
    serviceList: 'Service List',
    opdHistory: 'OPD History',
    opdHistoryDetail: 'OPD History Detail',
    comment: 'Comment',
    opinion: 'Opinion',
    summaryOpinion: 'Summary of Opinion',
    docs: 'Documents',
    beforeAfter: 'Before-After Images',
    dateDdMmYy: 'DD/MM/YY',
    commenter: 'Commenter',
    no: 'No.',
    date: 'Medication Date',
    ref: 'Reference Document',
    medicinPrice: 'Medication Fee (Baht)',
    buyDate: 'Purchase Date',
    expiraDate: 'Expiration Date',
    price: 'Price (Baht)',
    beforeImg: 'Before Treatment',
    afterImg: 'After Treatment',
    addBy: 'Added By',
    size: 'Size'
  },
  label: {
    openNewOpd: 'Open New OPD',
    registerPatient: 'Register Patient',
    orderMedicine: 'Order Medicine',
    qty: 'Quantity',
    deleteOPD: 'Delete OPD Data',
    weight: 'Weight',
    KG: '(Kilogram)',
    G: 'Gram',
    kg: 'kg',
    height: 'Height',
    CM: '(Centimeter)',
    cm: '(cm)',
    bmi: 'BMI',
    bloodPressure: 'Blood Pressure',
    SYS: 'Systolic (SYS)',
    DIA: 'Diastolic (DIA)',
    heartRate: 'Heart Rate',
    breathing: 'Respiratory Rate',
    healthConditionNormal: 'General condition is within normal range',
    temperature: 'Temperature',
    diagnosis: 'Diagnosis',
    symptom: 'Symptom',
    bloodPressureMmHg: 'mmHg / Pulse',
    editSymptom: 'Edit Symptom',
    treatment: 'Treatment',
    treatmentDetail: 'Treatment Detail',
    treatmentPlan: 'Detail/Treatment Plan',
    recommendation: 'Recommendation',
    addTo: 'Add symptom to medical certificate / short med cert / treatment cert',
    createBy: 'Created By',
    createDate: 'Creation Date',
    editBy: 'Edited By',
    editDate: 'Edit Date',
    doctroComment: 'Doctor Comment',
    title: 'Title',
    content: 'Content',
    chiefComplaint: 'Chief Complaint (CC)',
    file: 'Attach File',
    productsAndFormulas: 'Prescribed Products and Formulas',
    service: 'Service',
    onlyOpd: 'Only images in this OPD',
    nomalRoom: 'General Room',
    exRoom: 'Examination Room',
    nomalRoomList: 'General Room List',
    exRoomList: 'Examination Room List',
    have: 'Have',
    notHave: 'Not Have'
  },
  placeholder: {
    searchOPD: 'Search OPD Number',
    enterEmail: 'Enter Email',
    weight: 'Enter Weight',
    KG: '(Kilogram)',
    kg: '(kg)',
    height: 'Enter Height',
    CM: '(Centimeter)',
    cm: '(cm)',
    bmi: 'BMI',
    bloodPressure: 'Enter Blood Pressure',
    heartRate: 'Enter Heart Rate',
    breathing: 'Enter Respiratory Rate',
    temperature: 'Enter Temperature',
    diagnosis: 'Enter Diagnosis',
    symptom: 'Enter Symptom',
    searchSymptom: 'Search Symptom',
    treatment: 'Enter Treatment',
    treatmentDetail: 'Enter Treatment Detail',
    recommendation: 'Enter Recommendation',
    createBy: 'Created By',
    createDate: 'Enter Creation Date',
    editBy: 'Edited By',
    editDate: 'Enter Edit Date',
    title: 'Enter Title',
    content: 'Enter Content',
    chiefComplaint: 'Chief Complaint (CC)',
    file: 'Attach File',
    beforeAfter: 'Add Before/After Images',
    docs: 'Add Document',
    selectDocs: 'Select Document',
    searchDocs: 'Search Document',
    selectedPaperSize: 'Select Paper Size',
    signatureFile: 'Select Signature File',
    preTreatmentImageFile: 'Select Before Treatment Image File',
    postTreatmentImageFile: 'Select After Treatment Image File'
  },
  alert: {
    deleteConfirm: 'Confirm OPD Deletion',
    deleteInfo1: 'You are about to delete OPD',
    deleteInfo2: 'Do you want to proceed?',
    deleteSuccess: 'OPD deleted successfully!',
    orderMedicineConfirm: 'Confirm Medication Order',
    orderMedicineInfo1: 'You are ordering medicine for OPD',
    openNewOpdConfirm: 'Confirm New OPD',
    openNewOpdInfo1: 'You are opening a new OPD',
    registerPatientConfirm: 'Confirm Patient Registration',
    registerPatientInfo1: 'You are registering a new patient',
    running: 'Processing!'
  },
  toolTip: {
    openNewOpd: '*To assign fee recipient / DF, select from product/service list above',
    nomalRoom: 'View General Room Info',
    exRoom: 'View Examination Room Info'
  },
  modal: {
    editBeforeAfter: 'Edit Before/After Image',
    confirmDelete: 'Confirm Deletion of Before/After Image',
    deleteImage: 'Delete Before/After Image',
    deleteImageInfo1: 'You are about to delete the before/after image',
    deleteImageInfo2: 'Do you want to proceed?',
    confirmDeleteDocs: 'Confirm Document Deletion',
    deleteDocsInfo1: 'You are about to delete a document?',
    delete: {
      room: 'Confirm Room Deletion',
      roomSubTitle: 'You are about to delete'
    }
  }
}
